import table from "./gsm7.json";

const BASIC = new Set(table.basic);
const EXTENSION = new Set(table.extension);
const SUBSTITUTIONS = table.substitutions;
const SIZES = { gsm7: { single: 160, multi: 153 }, ucs2: { single: 70, multi: 67 } };

export const LONG_URL = /http\S{96,}/g;

export function normalize(text) {
  return Array.from((text ?? "").replace(/\r\n?/g, "\n"), (char) =>
    Object.hasOwn(SUBSTITUTIONS, char) ? SUBSTITUTIONS[char] : char
  ).join("");
}

export function segmentsOf(text) {
  const chars = Array.from(normalize(text));
  const unicodeCharacters = [...new Set(chars.filter((c) => !BASIC.has(c) && !EXTENSION.has(c)))];
  const encoding = unicodeCharacters.length ? "ucs2" : "gsm7";
  const units = chars.map((c) =>
    encoding === "gsm7" ? (EXTENSION.has(c) ? 2 : 1) : c.codePointAt(0) > 0xffff ? 2 : 1
  );
  const { single, multi } = SIZES[encoding];
  const total = units.reduce((sum, unit) => sum + unit, 0);

  if (total <= single) {
    return { count: total === 0 ? 0 : 1, encoding, remaining: single - total, unicodeCharacters };
  }

  let count = 1;
  let used = 0;
  for (const unit of units) {
    if (used + unit > multi) {
      count += 1;
      used = 0;
    }
    used += unit;
  }
  return { count, encoding, remaining: multi - used, unicodeCharacters };
}

export function compose(body, { mediaCount = 0, pollPrompt = "", placeholderUrl }) {
  let text = body.replace(LONG_URL, placeholderUrl);
  if (mediaCount > 0) {
    const list = Array(mediaCount).fill(placeholderUrl).join("\n");
    const label = mediaCount === 1 ? "attachment" : "attachments";
    text = text.trim() ? `${text} View ${label}:\n${list}` : list;
  }
  if (pollPrompt) text += `\n${pollPrompt} ${placeholderUrl}`;
  return text;
}
